import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginAppComponent } from './login-app/login-app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import {TimesheetPortalComponent} from './timesheet-portal/timesheet-portal.component';
import { AuthGuard } from './AuthGuard';
import { GetDeleteTimesheetComponent } from './get-delete-timesheet/get-delete-timesheet.component';
import { QueryBuilderComponent } from './query-builder/query-builder/query-builder.component';

const routes: Routes = [
  {path:'', redirectTo:'/login',pathMatch:'full'},  
  {path:'login', component:LoginAppComponent},
  {path:'Header', component:HeaderComponent, canActivate: [AuthGuard]},
  {path:'Footer', component:FooterComponent, canActivate: [AuthGuard]},
  {path:'timesheet', component:TimesheetPortalComponent, canActivate: [AuthGuard]},
  {path:'getDeleteTimesheet', component:GetDeleteTimesheetComponent, canActivate: [AuthGuard]},
  { path: 'query-builder', component: QueryBuilderComponent, canActivate: [AuthGuard] }
  // {path: '**', redirectTo: '/login'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
